import * as React from 'react';
import * as teacher from "./style.module.scss";
export const Speaker = () => {
  return (
    <section className={teacher.teacher}>
      <div className={'container'}>
        <div className={teacher.teacher__wrap}>
          <div className={teacher.teacher__img}>
            <img
              src={'https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/EL.png'}
              alt={'Преподаватель Елена Лебедева'}
            />
          </div>

          <div className={teacher.teacher__info}>
            <h2 className={teacher.teacher__title}>Преподаватель</h2>
            <h3 className={teacher.teacher__subtitle}>Елена Лебедева</h3>
            <ul>
              <li className={teacher.teacher__item}>Эксперт по&nbsp;технологиям обучения и&nbsp;изучения языков</li>
              <li className={teacher.teacher__item}>Разработчик флагманских курсов Advance</li>
              <li className={teacher.teacher__item}>Методист онлайн-курсов</li>
              <li className={teacher.teacher__item}>Педагогический дизайнер</li>
              <li className={teacher.teacher__item}>Специалист в&nbsp;области игрофикации обучения</li>
              <li className={teacher.teacher__item}>Обучила более 5&nbsp;000 студентов в&nbsp;группах</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
